import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CreateQuoteIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CreateQuoteIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M6 6.99994H12"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 9.99994H10"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12.9999H8"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 11L21 14"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9998 19.4285V20.4285C18.9998 20.9808 18.5521 21.4285 17.9998 21.4285H4.27111C3.72456 21.4285 3.27926 20.9897 3.27122 20.4432L3.01492 3.01489C3.00672 2.45691 3.45678 2.00018 4.01481 2.00018H14.8946C15.1459 2.00018 15.3881 2.09487 15.5728 2.26538L18.9998 5.42871V7.42868"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M15.3035 2.07565C15.4678 2.18677 17.8786 4.39646 18.1768 4.626C18.4667 4.876 18.7416 5.14399 19.0001 5.4284L15.0156 5.3423C14.5799 5.32874 14.4378 5.23325 14.4287 4.79973V2.01299C14.7217 1.98314 15.0174 2.00436 15.3035 2.07565Z"
        stroke="#503291"
        strokeLinejoin="round"
      />
      <path
        d="M21.377 13.6261C21.7754 13.2278 21.9991 12.6875 21.9991 12.1241C21.9991 11.5608 21.7754 11.0205 21.377 10.6221C20.9786 10.2238 20.4384 10 19.875 10C19.3116 10 18.7714 10.2238 18.373 10.6221L14.363 14.6341C14.1252 14.8718 13.9512 15.1655 13.857 15.4881L13.02 18.3581C12.9949 18.4442 12.9934 18.5354 13.0156 18.6222C13.0379 18.7091 13.0831 18.7883 13.1464 18.8517C13.2098 18.9151 13.2891 18.9603 13.3759 18.9825C13.4627 19.0048 13.554 19.0032 13.64 18.9781L16.51 18.1411C16.8327 18.0469 17.1264 17.8729 17.364 17.6351L21.377 13.6261Z"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
export default CreateQuoteIcon
